import { Action, bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";
import { addModule } from "../../../../redux/educator/actions";
import { setInitialSteps } from "../../../../redux/shared/actions";
import { StateType } from "../../../../utils/types";
import { selectModuleSubmitLoading } from "../../../../redux/educator/selector";

const mapStateToProps = (state: StateType) => ({
  submitLoading: selectModuleSubmitLoading(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators(
    {
      addModule,
      setInitialSteps,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
